<template>
  <div class="metric-card">
    <div
      v-if="!isEmpty"
      class="metric-card__data"
      :class="[(invertColors ? !positiveData : positiveData) ? 'green' : 'red']">
      <img
        v-if="invertColors ? positiveData : !positiveData"
        class="mr-1"
        :class="{ 'rotate-arrow': invertColors }"
        src="@/assets/icons/arrow-red-down.svg"
        alt="arrow-red-down" />
      <img
        v-if="invertColors ? !positiveData : positiveData"
        class="mr-1"
        :class="{ 'rotate-arrow': invertColors }"
        src="@/assets/icons/arrow-green-up.svg"
        alt="arrow-green-up" />
      {{ metricData }}%
    </div>
    <div v-else>-</div>
  </div>
</template>

<script>
  export default {
    name: "MetricCard",
    props: {
      metricData: {
        type: [String, Number],
        default: "",
      },
      invertColors: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isEmpty() {
        return this.metricData === "" ||
          this.metricData === "-" ||
          this.metricData === undefined ||
          this.metricData === null;
      },
      positiveData() {
        return !this.isEmpty && Number(this.metricData) >= 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .metric-card {
    @include text-body-2();
    color: get-color("body");

    &__data {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &.green {
        color: get-color("success");
      }
      &.red {
        color: get-color("error");
      }
    }

    .rotate-arrow {
      transform: rotateX(180deg);
    }
  }
</style>
